export interface DataResponse<T> {
    data: T;
}
